import { formatMetric } from '../panelConfig';

const div = (a, b) => (a != null && b ? a / b : null);

const COLUMNS = [
  { key: 'date', label: 'Fecha', format: 'date', align: 'left' },
  { key: 'revenue', label: 'Revenue', format: 'currency' },
  { key: 'target', label: 'Target', format: 'currency' },
  { key: 'pct_obj', label: '% Obj.', format: 'percent' },
  { key: 'orders', label: 'Órdenes', format: 'number' },
  { key: 'ticket', label: 'Ticket', format: 'currency' },
  { key: 'sessions', label: 'Sesiones', format: 'number' },
  { key: 'cr', label: 'CR %', format: 'percent' },
  { key: 'spend', label: 'Spend', format: 'currency' },
  { key: 'spend_google', label: 'Google', format: 'currency' },
  { key: 'spend_meta', label: 'Meta', format: 'currency' },
  { key: 'roas', label: 'ROAS', format: 'ratio' },
  { key: 'pct_mkt', label: '% mkt', format: 'percent' },
];

function toRow(d) {
  return {
    date: d.date,
    revenue: d.revenue,
    target: d.revenue_goal,
    pct_obj: div(d.revenue, d.revenue_goal),
    orders: d.orders,
    ticket: div(d.revenue, d.orders),
    sessions: d.sessions,
    cr: div(d.orders, d.sessions),
    spend: d.spend,
    spend_google: d.spend_google,
    spend_meta: d.spend_meta,
    roas: div(d.revenue, d.spend),
    pct_mkt: div(d.spend, d.revenue),
  };
}

/** Desglose diario del período (día más reciente primero). Tabla estética
 *  reporte; el panel/título lo pone EcomPanel (va dentro del scope .ecp). */
export default function DailyBreakdownTable({ daily }) {
  const rows = daily.map(toRow).reverse();
  return (
    <table className="ecp-table">
      <thead>
        <tr>
          {COLUMNS.map((c) => (
            <th key={c.key}>{c.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.date}>
            {COLUMNS.map((c) => (
              <td key={c.key}>{c.format === 'date' ? r[c.key] : formatMetric(r[c.key], c.format)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
